__turbopack_context__.v({
  "amount": "z2RWeG_amount",
  "pulse": "z2RWeG_pulse",
  "shimmer": "z2RWeG_shimmer",
});
